import { FormControl, Input, InputLabel, MenuItem, Select } from '@mui/material';
import BoxDrawer from 'components/BoxDrawer';
import ButtonConfirmAndClose from 'components/Buttons/ButtonConfirmAndClose';
import MuiPaper from 'components/MuiExtras/MuiPaper';
import { PublicationViewPriority } from 'models/ApiEnums';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    days: number;
}

interface IProps {
    onClose: (result: PublicationHighlightDrawerResult) => void;
}

type Props = IProps & WithTranslation;

export type PublicationHighlightDrawerResult = {
    days: number;
};

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class PublicationHighlightDrawer extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = { days: 3 };
    }

    public render() {
        const { onClose } = this.props;
        const { days } = this.state;

        return (
            <BoxDrawer
                open
                overflow="hidden"
                onClose={() => onClose(null)}
                title={this.props.t("Views.Timeline.Dialogs.PublicationHighlightDrawer.BoxTitle")}
            >
                <MuiPaper dense elevation={0}>

                    <FormControl fullWidth margin="dense">
                        <InputLabel shrink htmlFor="LabelDays">{this.props.t("Views.Timeline.Dialogs.PublicationHighlightDrawer.LabelText")}</InputLabel>

                        <Select
                            fullWidth
                            value={days}
                            input={<Input id="LabelDays" />}
                            onChange={
                                (e) => {
                                    this.setState({ days: parseInt(e.target.value as string) });
                                }
                            }
                        >
                            {
                                ["1", "3", "5", "10", "15", "30"].map((v, index) => <MenuItem key={index} value={v}>{v}</MenuItem>)
                            }
                        </Select>
                    </FormControl>


                    <ButtonConfirmAndClose
                        fullWidth
                        onClick={
                            () => {
                                onClose({ days });
                            }
                        }
                    />

                </MuiPaper>

            </BoxDrawer>
        );
    }
}

export default withTranslation()(PublicationHighlightDrawer);